<template>
  <div class="projectTop">
    <div class="projectTop-text">{{ platform.title }} <span v-if="platform.textLoading" @click="open">更多</span></div>
    <div class="allLoading" v-if="loading">
      <div class="allLoadingRelative indexJust">
        <div class="projectTop-alert" :class="{ bounceInOpen: loading }">
          <div class="header">{{ title }} <span @click="exit"></span></div>
          <div class="text" v-html="platform.info"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'projectTop',
  props: {
    title: '',
    platform: {
      title: '',
      info: '',
      textLoading: false,
    }
  },
  created() {
  },
  mounted() {},
  computed: {},
  data() {
    return {
      loading: false,
      textLoading: false
    };
  },
  mounted() {},
  methods: {
    open() {
      this.loading = true;
      this.$emit('openCallBack');
    },
    exit() {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/statisticsLevel/common/projectDetails.scss';
</style>



// WEBPACK FOOTER //
// src/views/businessModule/projectDetails.vue